/**
 * 申请售后相关API
 */

import request from '@/utils/request'

/**
 * 获取转入转出银行
 * params currencyShort,充值货币简称;bankType,支付方式
 * @returns {AxiosPromise}
 */
export function getBankList(params) {
  return request({
    url: '/recharge/bank_list',
    method: 'post',
    ApiBase: false,
    needToken: true,
    loading: false,
    data: params
  })
}

/**
 * 充值币种公司银行账号
 * params currencyShort,充值货币简称
 * @returns {AxiosPromise}
 */
export function getCompanyBank(params) {
  return request({
    url: '/recharge/company_bank',
    method: 'post',
    ApiBase: false,
    needToken: true,
    loading: false,
    data: params
  })
}

/**
 * 充值申请
 * params
 * @returns {AxiosPromise}
 */
export function rechargeApply(params) {
  return request({
    url: '/recharge/apply',
    method: 'post',
    timeout: 600000,
    ApiBase: false,
    needToken: true,
    loading: true,
    data: params,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 * 取现申请
 * params
 * @returns {AxiosPromise}
 */
export function withdrawApply(params) {
  return request({
    url: '/withdraw/apply',
    method: 'post',
    ApiBase: false,
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * 取现费率
 * @returns {AxiosPromise}
 */
export function withdrawFee() {
  return request({
    url: '/web/config/txFee',
    method: 'get',
    ApiBase: false,
    needToken: true,
    loading: true
  })
}
